import { Authentication, PersonalTrainerUser } from './types'

export function getActingPersonalTrainerId(session?: Authentication) {
  if (!session) return undefined

  if (session.role === 'personalTrainer') {
    return (session.user as PersonalTrainerUser).id
  }

  if (session.role === 'admin') {
    return session.impersonation?.personalTrainerId
  }

  return undefined
}

export function getActingPersonalTrainerName(session?: Authentication) {
  if (!session) return undefined

  if (session.role === 'personalTrainer') {
    return (session.user as PersonalTrainerUser).name
  }

  if (session.role === 'admin') {
    return session.impersonation?.personalTrainerName
  }

  return undefined
}

export function isActingAsPersonalTrainer(session?: Authentication) {
  return !!getActingPersonalTrainerId(session)
}
